import { useEffect } from 'react';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import LineGraph from 'pages/InsightsPage/visualizations/LineGraph';
import CustomTooltip from 'pages/InsightsPage/visualizations/CustomTooltip';

type Props = {
    filtersForApi: FiltersForApiState;
};

const OptOutRateOverTimeCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/opt-out-rate-over-time',
        path: CuredApiPaths.REPORT_VOICE_OPT_OUT_RATE_OVER_TIME,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    const renderCustomTooltip = (point: any) => (
        <CustomTooltip
            color={point.serieColor}
            label={`unsubscribe date - ${point.data.xFormatted}`}
            value={`opt-out count - ${point.data.yFormatted}`}
        />
    );

    return (
        <Card isError={isError} isLoading={isLoading} label="Opt Out Rate over Time">
            <LineGraph data={[data]} leftLegendLabel="total unsubscribes" renderCustomTooltip={renderCustomTooltip} />
        </Card>
    );
};

export default OptOutRateOverTimeCard;
